export const getVodUrlDetails = urlString => {
  const vodUrl = new URL(urlString)
  return {
    vodPlatform: vodUrl.hostname.includes('twitch') ? 'twitch' : 'youtube',
    vodId: vodUrl.searchParams.get('v') || vodUrl.pathname.split('/').pop(),
  }
}
